import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const _GetFacilityAlertsAndFlagsChartRequestDtoSchema = z.object({
  facilityId: z.number(),
  from: z.string().refine((val) => !isNaN(Date.parse(val)), 'Invalid datetime'),
  to: z.string().refine((val) => !isNaN(Date.parse(val)), 'Invalid datetime'),
  granularity: z.enum(['week', 'month']).optional(),
});

const GetFacilityAlertsAndFlagsChartResponseDtoSchema = z.object({
  createdAlerts: z.object({
    count: z.number().nullable(),
    changePct: z.number().nullable(),
  }),
  activeAlerts: z.object({
    count: z.number().nullable(),
  }),
  avgDaysToResolve: z.object({
    count: z.number().nullable(),
    changePct: z.number().nullable(),
  }),
  createdFlags: z.object({
    count: z.number().nullable(),
    changePct: z.number().nullable(),
  }),
  chart: z.object({
    granularity: z.enum(['week', 'month']),
    points: z.array(
      z.object({
        start: z.string(),
        end: z.string(),
        createdAlerts: z.number().nullable(),
        createdFlags: z.number().nullable(),
      })
    ),
  }),
});

export type GetFacilityAlertsAndFlagsChartRequestDto = z.infer<
  typeof _GetFacilityAlertsAndFlagsChartRequestDtoSchema
>;
export type GetFacilityAlertsAndFlagsChartResponseDto = z.infer<
  typeof GetFacilityAlertsAndFlagsChartResponseDtoSchema
>;

export const getFacilityAlertsAndFlagsChart = (
  params: GetFacilityAlertsAndFlagsChartRequestDto,
  config?: AxiosRequestConfig<GetFacilityAlertsAndFlagsChartRequestDto>
) => {
  const { facilityId, ...restParams } = params;

  return api
    .get(`/facilities/${facilityId}/alerts-and-flags-chart`, {
      params: restParams,
      ...config,
    })
    .then(responseContract(GetFacilityAlertsAndFlagsChartResponseDtoSchema));
};
